import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full p-6" }
const _hoisted_2 = { class: "bg-white shadow-md rounded-lg p-6 mb-6" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = {
  key: 0,
  class: "bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "bg-white shadow-md rounded-lg p-6 mb-6" }
const _hoisted_7 = {
  key: 0,
  class: "overflow-x-auto"
}
const _hoisted_8 = { class: "min-w-full bg-white" }
const _hoisted_9 = { class: "py-2 px-4 border-b border-gray-200" }
const _hoisted_10 = { class: "py-2 px-4 border-b border-gray-200" }
const _hoisted_11 = { class: "py-2 px-4 border-b border-gray-200" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "bg-white shadow-md rounded-lg p-6 mb-6"
}
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = { class: "border rounded p-4 bg-gray-50 h-64 overflow-auto relative" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "mb-4" }
const _hoisted_20 = { class: "flex justify-end space-x-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")!
  const _component_EmailPreviewModal = _resolveComponent("EmailPreviewModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "text-2xl font-bold mb-2" }, "Email Generator", -1)),
    _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-muted-foreground mb-4" }, "Create and manage automated email communications based on reporting calendars", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "text-xl font-bold mb-4" }, "1. Upload Reporting Calendar", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("label", {
          class: "block text-gray-700 text-sm font-bold mb-2",
          for: "calendar-file"
        }, " Select Excel File ", -1)),
        _createElementVNode("input", {
          type: "file",
          id: "calendar-file",
          accept: ".xlsx, .xls",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
          class: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        }, null, 32)
      ]),
      (_ctx.uploadError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.uploadError), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.parseFile && _ctx.parseFile(...args))),
        disabled: !_ctx.selectedFile,
        class: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline disabled:opacity-50"
      }, " Parse Calendar ", 8, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "text-xl font-bold mb-4" }, "2. Saved Drafts", -1)),
      (_ctx.savedDrafts.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "py-2 px-4 border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider" }, " Subject "),
                  _createElementVNode("th", { class: "py-2 px-4 border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider" }, " Created At "),
                  _createElementVNode("th", { class: "py-2 px-4 border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider" }, " Actions ")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.savedDrafts, (draft) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: draft.id
                  }, [
                    _createElementVNode("td", _hoisted_9, _toDisplayString(draft.subject), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.formatDate(draft.createdAt)), 1),
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.loadEmailDraft(draft.id)),
                        class: "text-blue-500 hover:text-blue-700 mr-2"
                      }, " Load ", 8, _hoisted_12),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.showDeleteConfirmation(draft.id, draft.subject)),
                        class: "text-red-500 hover:text-red-700"
                      }, " Delete ", 8, _hoisted_13)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : (_openBlock(), _createBlock(_component_EmptyState, {
            key: 1,
            icon: "document",
            title: "No Saved Drafts",
            message: "You haven't saved any email drafts yet. After creating a draft, click 'Save Draft' to save it here.",
            iconClass: "text-gray-400"
          }))
    ]),
    (_ctx.emailDraft)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "text-xl font-bold mb-4" }, "3. Email Draft Preview", -1)),
          _createElementVNode("div", _hoisted_15, [
            _cache[13] || (_cache[13] = _createElementVNode("label", {
              class: "block text-gray-700 text-sm font-bold mb-2",
              for: "email-subject"
            }, " Subject ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "email-subject",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.emailDraft.subject) = $event)),
              class: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            }, null, 512), [
              [_vModelText, _ctx.emailDraft.subject]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block text-gray-700 text-sm font-bold mb-2" }, " HTML Content ", -1)),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", { innerHTML: _ctx.processedHtmlContent }, null, 8, _hoisted_18),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showPreviewModal = true)),
                class: "absolute top-2 right-2 bg-white p-1 rounded-md shadow hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500",
                title: "View in full screen"
              }, _cache[14] || (_cache[14] = [
                _createElementVNode("svg", {
                  class: "h-5 w-5 text-gray-500",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4 0l-5-5"
                  })
                ], -1)
              ]))
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block text-gray-700 text-sm font-bold mb-2" }, " Text Content ", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.emailDraft.textContent) = $event)),
              class: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline h-32",
              readonly: ""
            }, null, 512), [
              [_vModelText, _ctx.emailDraft.textContent]
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clearEmailDraft && _ctx.clearEmailDraft(...args))),
              class: "bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            }, " Clear "),
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.saveEmailDraft && _ctx.saveEmailDraft(...args))),
              class: "bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            }, " Save Draft ")
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmationModal, {
      isOpen: _ctx.showDeleteModal,
      "onUpdate:isOpen": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showDeleteModal) = $event)),
      title: "Delete Email Draft",
      message: `Are you sure you want to delete the email draft '${_ctx.draftToDeleteSubject}'?`,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      confirmButtonClass: "bg-red-600 hover:bg-red-700 text-white focus:ring-red-500",
      iconType: "warning",
      onConfirm: _ctx.confirmDelete
    }, null, 8, ["isOpen", "message", "onConfirm"]),
    _createVNode(_component_EmailPreviewModal, {
      isOpen: _ctx.showPreviewModal,
      "onUpdate:isOpen": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showPreviewModal) = $event)),
      subject: _ctx.emailDraft?.subject || '',
      htmlContent: _ctx.emailDraft?.htmlContent || '',
      textContent: _ctx.emailDraft?.textContent || ''
    }, null, 8, ["isOpen", "subject", "htmlContent", "textContent"])
  ]))
}